import request from "@/libs/request";
import {
  CreateAlertRequest,
  CreateAlertResponse,
  ReadAlertsRequest,
  ReadAlertsResponse,
} from "@/types/alert";

// 알림 생성
export const createAlert = async (
  data: CreateAlertRequest
): Promise<CreateAlertResponse> => {
  const response = await request.post<CreateAlertResponse>(
    `/alerts/create`,
    data
  );
  return response.data;
};

// 사용자 알림 목록 조회
export const readAlerts = async (
  data: ReadAlertsRequest
): Promise<ReadAlertsResponse> => {
  const response = await request.post<ReadAlertsResponse>(`/alerts/read`, data);
  return response.data;
};
